/* eslint-disable no-console */

import { unregister } from 'register-service-worker'

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'stage') {
  unregister()
}



// WEBPACK FOOTER //
// ./src/register-sw.js